module.exports = AuthCtrl;

// @ngInject
function AuthCtrl($state, $anchorScroll, SiteVisitApi, Alert, localStorageService) {
	try {
		var vm = this;
		vm.moduleName = 'AuthCtrl'
		vm.authCode = null;

		console.log(vm.moduleName, localStorageService.get('state'))
    if (localStorageService.get('state') === null) {
      $state.go('unknown');
    }

		vm.authConfirm = function () {
			try {
				vm.busyMsg = "Authenticate";
				vm.isBusy = true;

				SiteVisitApi.authConfirm(vm.authCode, JSON.parse(localStorageService.get('position')), localStorageService.get('visitId')).then(
					function(data) {
						try {
							vm.isBusy = false;
							switch (data.status) {
								case 'OK':
									console.log('authConfirm:', data);
									localStorageService.set('visitMessages', JSON.stringify(data.messages.message));

									// If this is a re-visit with state 'ONSITE' - skip onsite check-in
									if ((data.visitStatus === 'ONSITE' ||  data.visitStatus === 'CALL_NOC') && localStorageService.get('visitType') === 'UPDATE') {
										$state.go('messages');
									} else {
										localStorageService.set('state', data.visitStatus);
										vm.state = data.visitStatus;
										$state.go('onsite');
									}
									break;
								case 'INVALID_CODE':
									Alert.addAlert({ title: 'Error', message: 'Invalid access code: ' + vm.authCode, type: 'infoAlert', alertClass: 'alert-danger'});
									$anchorScroll();
									break;
								default:
									Alert.addAlert({ title: 'Error', message: 'Unexpected error: ' + data.message, type: 'errorAlert', alertClass: 'alert-danger'});
									$anchorScroll();
							}
						} catch(error) {
							vm.isBusy = false;
							Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName});
							$anchorScroll();
						}
					},
					function(error) {
						vm.isBusy = false;
						Alert.addAlert({ title: 'Error', message: error, type: 'errorAlert', alertClass: 'alert-danger'});
						$anchorScroll();
					}
				)
			} catch(error) {
				vm.isBusy = false;
				Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName});
				$anchorScroll();
			}
		}
	} catch(error) {
		vm.isBusy = false;
		Alert.addAlert({ title: 'Ooops - a system error has occurred', message: error, type: 'errorAlert', alertClass: 'alert-danger', report: true, appModule: vm.moduleName} );
		$anchorScroll();
	}
};
